import { InjectionToken } from '@angular/core';

export const CHARGEBEE_SITE = new InjectionToken<string>('CHARGEBEE_SITE');
